import { Handshake } from "lucide-react";

/**
 * The PriceOnline lockup, matching `frontendv2/components/ui/logo.tsx`.
 *
 * Drawn rather than served as an image. `public/logo.png` is a dark-header asset — fully opaque on
 * near-black — so on a light surface it renders as a black box, and the storefront does not use it
 * either: its logo is this lucide glyph in yellow beside the wordmark in Big Shoulders. Drawing it
 * keeps the admin and the shop identical with no exported image to keep in step.
 *
 * Sized at 80 % of the storefront's, which suits a 70px header, and the only place Big Shoulders
 * appears in the admin — everything else is Poppins. The wordmark inherits `currentColor`, so one
 * component reads white on the dark rail and ink on the login card.
 *
 * **The wordmark is what gets centred, not the lockup.** Centring the whole icon-and-text block is
 * geometrically correct and looks wrong: the glyph and its gap are 30px, so the word lands 15px
 * right of centre and the eye — which reads the word as the logo — sees it pushed over. The icon
 * therefore hangs outside the flow, to the left of a wordmark that is centred on its own.
 */
export const BrandMark = ({
	iconOnly = false,
	className = "",
}: {
	iconOnly?: boolean;
	className?: string;
}) => {
	if (iconOnly) {
		return (
			<span className={`flex w-full items-center justify-center ${className}`}>
				<Handshake className="h-[22px] w-[22px] text-yellow-500" />
			</span>
		);
	}

	return (
		<span className={`flex w-full items-center justify-center ${className}`}>
			<span className="relative">
				<Handshake className="absolute right-full top-1/2 mr-2 h-[22px] w-[22px] -translate-y-1/2 text-yellow-500" />
				<span className="font-display whitespace-nowrap text-[21px] font-light leading-none tracking-[0.022rem] text-current">
					PriceOnline
				</span>
			</span>
		</span>
	);
};
